import { render, staticRenderFns } from "./TrafficPoolNew.vue?vue&type=template&id=72b98d5b&scoped=true&"
import script from "./TrafficPoolNew.vue?vue&type=script&lang=js&"
export * from "./TrafficPoolNew.vue?vue&type=script&lang=js&"
import style0 from "./TrafficPoolNew.vue?vue&type=style&index=0&id=72b98d5b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b98d5b",
  null
  
)

export default component.exports